var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriceTagBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 0H9.12485C8.75825 0 8.24587 0.212381 7.98685 0.471208L0.389089 8.06893C-0.129696 8.58713 -0.129696 9.43673 0.389089 9.95431L6.04624 15.6113C6.56385 16.1295 7.41264 16.1295 7.93103 15.6107L15.5288 8.01412C15.7876 7.75534 16 7.24214 16 6.87632V1.33339C16 0.600191 15.3998 0 14.6666 0ZM11.9998 5.33336C11.2634 5.33336 10.6664 4.73575 10.6664 3.99997C10.6664 3.26299 11.2634 2.66658 11.9998 2.66658C12.7362 2.66658 13.3334 3.26299 13.3334 3.99997C13.3334 4.73575 12.7362 5.33336 11.9998 5.33336Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceTagBlack);
export default __webpack_public_path__ + "static/media/price_tag_black.3808bdd15cf1c338e054ac063bcd1ac1.svg";
export { ForwardRef as ReactComponent };